import ClassStateLabel from './class-state-label-view'

export default ClassStateLabel
